<template>
    <div>
        <Header @navTarget="getNavbar"></Header>
        <div v-if="activeHeader=='courseSelect'">
            <CourseSelect></CourseSelect>
        </div>
        <div v-if="activeHeader=='courseMall'" class="page-content">
            <CourseMall></CourseMall>
        </div>
        <div v-if="activeHeader=='teacherHome'" class="page-content">
            <TeacherHome></TeacherHome>
        </div>
        <div v-if="activeHeader=='liveClass'" class="page-content">
            <LiveClass></LiveClass>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import LiveClass from './components/LiveClass.vue'
import CourseMall from './components/CourseMall.vue'
import TeacherHome from './components/TeacherHome.vue'
import CourseSelect from './components/CourseSelect.vue'
export default {
    name: '',
    components:{
      Header,
      Footer,
      CourseSelect,
      CourseMall,
      TeacherHome,
      LiveClass
    },
    data() {
        return {
            activeHeader:''
        }
    },
    mounted(){
        
    },
    methods: {
        getNavbar(target){
            this.activeHeader=target;
        }
    }
}
</script>

<style scoped>
.page-content{
    width:1200px;
    margin:0 auto;
    margin-top:100px;
}
</style>


